import { render } from "./template.vue?vue&type=template&id=1e78c16f"
const script = {}

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__